module.exports = __webpack_public_path__ + "img/code.677afbd9.png";